import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
import { nextIteration } from "./_nextIteration.js";
import { nextIterationWithIndex } from "./_nextIterationWithIndex.js";
export const select = (source, key) => {
    if (typeof key === "function") {
        if (key.length === 1) {
            return new BasicParallelEnumerable(nextIteration(source, key));
        }
        else {
            return new BasicParallelEnumerable(nextIterationWithIndex(source, key));
        }
    }
    else {
        return new BasicParallelEnumerable(nextIteration(source, (x) => x[key]));
    }
};
